import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import pagesStyle from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

const Pages = (props) => {
  async function componentDidMount() {}
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    componentDidMount();
  }, []);

  useEffect(() => {
    if (window.innerWidth >= 960) {
      document.body.style.overflow = "unset";
    }
  });

  return (
    <div style={{ width: "100%" }}>
      <Outlet />
    </div>
  );
};

Pages.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(pagesStyle)(Pages);
